
import { required, digits, email, max, regex } from "vee-validate/dist/rules";
import consultationTypes from "../ts/consultation_types";

import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    delay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showRequest: false,
      contactTypeList: ["WhatsApp", "Telegram", "E-mail"],
      fromTypeList: [
        "Социальные сети",
        "Поиск в интернет",
        "По рекомендации",
        "По ссылке на сайте",
        "Другое",
      ],
      preferContactType: "WhatsApp",
      fromType: "",
      consultationType: "office",
      submitFormSuccess: false,
      dialog: false,
      name: "",
      phoneNumber: "",
      email: "",
      select: null,
      checkbox: null,
      checkbox2: null,
      message: "",
    };
  },
  mounted() {
    if (this.delay) {
      setTimeout(() => {
        this.showRequest = true;
      }, 2000);
    } else {
      this.showRequest = true;
    }
  },
  methods: {
    submit() {
      this.$refs.observer.validate();

      const url = `${this.$config.wwwURL}${this.$route.fullPath}`;
      const emailData = {
        from: "no-reply@elena-elizarova.ru",
        subject: "Contact form message",
        text: `ФИО: ${this.name}\nТел: ${this.phoneNumber}\nПредпочтительный вид связи: ${this.preferContactType}\nE-mail: ${this.email}\nТип консультации:${this.consultationType}\nОткуда узнали: ${this.fromType}\nСтраница: ${url}\nСообщение:\n${this.message}`,
      };

      this.$axios
        .$post(`${this.$config.wwwURL}/mail/send`, emailData, {
          retries: 3, // number of retries
          retryDelay: (retryCount) => {
            console.log(`retry attempt: ${retryCount}`);
            return retryCount * 500; // time interval between retries
          },
        })
        .then((response) => {
          if (process.client && ym !== undefined && !this.$config.isDev) {
            ym(73133527, "reachGoal", `LEAD`, { order_price: 1000, currency: "RUB" });
          }
          this.submitFormSuccess = true;
          alert("Заявка успешно отправлена");
        })
        .catch((err) => {
          console.log(
            `[${err.response && err.response.status}] ${
              err.response && err.response.request.path
            }`
          );
          console.log(err.response && err.response.data);
          alert(
            "Заявку не удалось отправить. Свяжитесь по телефону или онлайн на сайте."
          );
        });

      const jsonData = {
        subject: "ClientRequest",
        consultationType: this.consultationType,
        fromType: this.fromType,
        url: url,
      };

      const apiURL = `${this.$config.apiURL}/json?source=${this.$route.path}`;
      //console.log('saveResults', url)
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: apiURL,
        data: jsonData,
        retries: 3, // number of retries
        retryDelay: (retryCount) => {
          console.log(`retry attempt: ${retryCount}`);
          return retryCount * 500; // time interval between retries
        },
        headers: {},
      };

      this.$axios.request(config).catch((error) => {
        console.log("error", error);
      });
    },
  },
  computed: {
    consultationTypeList: function () {
      const res = [];
      consultationTypes.data.forEach((item) => {
        if (item.price) {
          res.push(`${item.name} - ${item.price} ${item.currency} ${item.duration}`);
        } else {
          res.push(`${item.name} - Стоимость оговаривается индивидуально`);
        }
      });

      return res;
    },
  },
};

setInteractionMode("eager");

extend("digits", {
  ...digits,
  message: "Должно быть {length} цифр.",
});

extend("required", {
  ...required,
  message: "Поле не может быть пустым",
});

extend("max", {
  ...max,
  message: "{_field_} may not be greater than {length} characters",
});

extend("regex", {
  ...regex,
  message: "Значние {_value_} не соответствует формату +79998887766 или 89998887766.",
});

extend("email", {
  ...email,
  message: "Email указан некорректно",
});
